import { Route } from '@angular/router';

import { subscriptionCheckoutGuard } from './guards/subscription-checkout.guard';
import { subscriptionCompleteUnloadGuard } from './guards/subscription-complete-unload.guard';
import { subscriptionCompleteGuard } from './guards/subscription-complete.guard';
import { subscriptionErrorGuard } from './guards/subscription-error.guard';
import { subscriptionProcessingUnloadGuard } from './guards/subscription-processing-unload.guard';
import { subscriptionProcessingGuard } from './guards/subscription-processing.guard';
import { subscriptionSuccessGuard } from './guards/subscription-success.guard';

export const SUBSCRIPTION_ROUTES: Route[] = [
  {
    path: '',
    redirectTo: 'upgrade',
    pathMatch: 'full',
  },
  {
    path: 'upgrade',
    loadComponent: () => import('./pages/plans/plans.page').then((c) => c.PlansPage),
  },
  {
    path: 'checkout',
    loadComponent: () =>
      import('./pages/subscription-checkout/subscription-checkout.page').then((c) => c.SubscriptionCheckoutPage),
    canActivate: [subscriptionCheckoutGuard],
  },
  {
    path: 'complete',
    loadComponent: () =>
      import('./pages/subscription-complete/subscription-complete.page').then((c) => c.SubscriptionCompletePage),
    canActivate: [subscriptionCompleteGuard],
    canDeactivate: [subscriptionCompleteUnloadGuard],
  },
  {
    path: 'processing',
    loadComponent: () =>
      import('./pages/subscription-processing/subscription-processing.page').then((c) => c.SubscriptionProcessingPage),
    canActivate: [subscriptionProcessingGuard],
    canDeactivate: [subscriptionProcessingUnloadGuard],
  },
  {
    path: 'success',
    loadComponent: () =>
      import('./pages/subscription-success/subscription-success.page').then((c) => c.SubscriptionSuccessPage),
    canActivate: [subscriptionSuccessGuard],
  },
  {
    path: 'error',
    loadComponent: () =>
      import('./pages/subscription-error/subscription-error.page').then((c) => c.SubscriptionErrorPage),
    canActivate: [subscriptionErrorGuard],
  },
];
